import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=8265f9b0&scoped=true&lang=pug&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=8265f9b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265f9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8265f9b0', component.options)
    } else {
      api.reload('8265f9b0', component.options)
    }
    module.hot.accept("./textarea.vue?vue&type=template&id=8265f9b0&scoped=true&lang=pug&", function () {
      api.rerender('8265f9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/textarea.vue"
export default component.exports